import { useEffect } from "react";
/**
 * @description
 * Use this hook to listen to custom events on the window object.
 * 
 * @example
 * useCustomEvent('some event name', (e) => {
 *  const event = e as CustomEvent<TheDetailType>;
 *
 *  someFunction(event.detail);
 * });
 */ export const useCustomEvent = (eventName, cb, dependencies = [])=>{
  useEffect(()=>{
    function callbackHandler(event) {
      if (cb) {
        void cb(event);
      }
    }
    window.addEventListener(eventName, callbackHandler);
    return ()=>{
      window.removeEventListener(eventName, callbackHandler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
//# sourceMappingURL=useCustomEvent.js.map